/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 1500 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Marcus Santos",
  title: "Hi, I'm Marcus Santos",
  subTitle: 
    <>Senior Software Engineer with 9+ years of experience in Full-Stack, Backend & Mobile Application Development (Android & iOS)<br />
    Experienced in building scalable web and cloud-based systems, distributed architectures, intelligent automation features and CI/CD-driven development workflows across SaaS and enterprise environments<br /> Focused on performance optimization, reliability, maintainability and long-term product scalability</>

  ,
  resumeLink:
    "", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/MarcusViniciusBispoDosSantos",
  linkedin: "https://www.linkedin.com/in/marcus-santos-456157430/",
  gmail: "marcusviniciusdossantosbr@gmail.com",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRISP AND EFFICIENT SOFTWARE SOLUTIONS",
  skills: [
    emoji("⚡ Full-Stack Web Development (React, Node.js, Express, Next.js, Python, WordPress)"),
    emoji("⚡ Mobile App Development (Android & iOS)"),
    emoji("⚡ Cloud Architecture: AWS, GCP, Azure"),
    emoji("⚡ CI/CD Automation & DevOps"),
    emoji("⚡ Microservices & Scalable System Design"),
    emoji("⚡ AI & ML Integration including LLMs (Chatbots, Recommendations, Prediction)"),
    emoji("⚡ Monitoring, Logging & Observability for High Reliability")
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "HTML-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "CSS3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "Sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "WordPress",
      fontAwesomeClassname: "fab fa-wordpress"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "React",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "Node.js",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "Swift",
      fontAwesomeClassname: "fab fa-swift"
    },
    {
      skillName: "Python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "NPM",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "SQL",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "Firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "Docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "Android",
      fontAwesomeClassname: "fab fa-android"
    },
    {
      skillName: "iOS",
      fontAwesomeClassname: "fab fa-apple"
    },{
      skillName: "CI/CD",
      fontAwesomeClassname: "fas fa-sync-alt"
    },
    {
      skillName: "DevOps",
      fontAwesomeClassname: "fas fa-tools"
    },
    {
      skillName: "AWS",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "GCP",
      fontAwesomeClassname: "fab fa-google"
    },
    {
      skillName: "Azure",
      fontAwesomeClassname: "fab fa-microsoft"
    },
    {
      skillName: "AI",
      fontAwesomeClassname: "fas fa-brain"
    },
    {
      skillName: "LLM",
      fontAwesomeClassname: "fas fa-comment-dots"
    },
    {
      skillName: "OpenAI / GPT",
      fontAwesomeClassname: "fas fa-microchip"
    },
    {
      skillName: "AI APIs Integration",
      fontAwesomeClassname: "fas fa-plug"
    },
    {
      skillName: "Microservices",
      fontAwesomeClassname: "fas fa-cubes"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "UFBA - Universidade Federal da Bahia",
      subHeader: "Bachelor’s Degree in Computer Science",
      logo: require("./assets/images/ufba_logo.jpg"),
      duration: "Mar 2013 – Dec 2016",
      desc: "Studied programming, data structures, algorithms, databases, operating systems, and system design. Built academic and practical projects covering backend, web, and end-to-end software systems.",
      grade: "8.5 / 10",
      descBullets: [
        <>Built strong foundations in software engineering, algorithms, databases and operating systems</>,
        <>Developed academic projects involving web applications, backend systems and database modeling</>,
        <>Worked on collaborative software development projects using Git-based workflows</>,
        <>Completed a capstone project involving full system design and implementation</>,

      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "87%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "85%"
    },
    {
      Stack: "Programming",
      progressPercentage: "95%"
    }
  ],
  displayCodersrank: true // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
    role: "Senior Software Engineer",
    company: "BetterEngineer\n\n(US – Remote)",
    companylogo: require("./assets/images/salsamobi_logo.jpg"),
    date: "Apr 2022 – Present",
    descBullets: [
      <>Developed scalable web, backend and mobile applications for Android and iOS platforms across SaaS and e-commerce environments</>,
      <>Designed and maintained cloud-based infrastructure using AWS, GCP and Azure, supporting 2–3× traffic growth while maintaining high availability and operational stability</>,
      <>Built RESTful APIs, backend services and distributed application workflows supporting high-traffic production systems</>,
      <>Improved frontend and API performance, reducing application load times by 30–45% across multiple projects</>,
      <>Developed and enhanced cross-platform mobile applications integrating backend APIs, cloud services and real-time communication features</>,
      <>Improved CI/CD pipelines and deployment automation, reducing release cycles by 40% and minimizing deployment-related production issues</>,
      <>Participated in modernization initiatives migrating legacy systems into scalable service-oriented architectures</>,
      <>Integrated intelligent automation features including customer support chat systems, recommendation workflows and operational automation tools</>,
      <>Implemented monitoring, logging and observability solutions, improving production visibility and enabling faster incident response</>,
      <>Collaborated with distributed engineering, product and design teams in fully remote environments</>
    ]
  },
  {
    role: "Full-Stack Engineer",
    company: "Savas Labs\n\n(US – Remote)",
    companylogo: require("./assets/images/savas_lab_logo.jpg"),
    date: "Sep 2019 – Mar 2022",
    descBullets: [
      <>Contributed to full-stack application development across frontend, backend, APIs and cloud infrastructure</>,
      <>Developed scalable cloud-based solutions using AWS, GCP and Azure for customer-facing platforms and distributed services</>,
      <>Improved deployment consistency through CI/CD automation, shortening release cycles by 40–50%</>,
      <>Contributed to Android and iOS mobile application development integrated with scalable backend systems and APIs</>,
      <>Assisted in migrating legacy applications into modern distributed architectures, improving platform reliability, scalability and operational stability</>,
      <>Built and integrated intelligent automation workflows including chat automation, recommendation systems and analytics-related features</>,
      <>Enhanced monitoring and logging processes to improve production stability and operational visibility</>,
      <>Participated in architecture discussions, code reviews and technical mentoring across distributed engineering teams</>,

    ]
  },
  {
    role: "Software Developer",
    company: "Sotero Tech\n\n(BR - Hybrid)",
    companylogo: require("./assets/images/sotero_tech_logo.jpg"),
    date: "Jan 2017 – Aug 2019",
    descBullets: [
      <>Developed and maintained production systems supporting hundreds of active users across multiple business environments</>,
      <>Improved backend workflows and system reliability, reducing recurring post-release issues by 20–30%</>,
      <>Assisted with deployment automation, monitoring and cloud infrastructure improvements</>,
      <>Worked on backend services and database-driven applications focused on performance, scalability and maintainability</>,
      <>Supported frontend and mobile-related feature development integrated with backend APIs and cloud services</>,
      <>Collaborated with cross-functional teams on software architecture and feature delivery initiatives</>,
      <>Helped optimize application performance and reduce operational bottlenecks under increasing workloads</>,
    ]
  }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  subtitle: "SOME PROJECRS THAT I HAVE DONE!",
  projects: [
    {
      image: require("./assets/images/OpsPilot.png"),
      projectName: "OpsPilot Voice",
      projectDesc: "OpsPilot Voice is an AI Incident Commander",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://opspilot-voice.onrender.com/"
        }
      ]
    },
    {
      image: require("./assets/images/saayaHealthLogo.png"),
      projectName: "Saayahealth",
      projectDesc: "Culturally sensitive employee support services",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://saayahealth.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/nextuLogo.png"),
      projectName: "Nextu",
      projectDesc: "Video-based candidate presentations",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://nextu.se/"
        }
      ]
    },
    {
      image: require("./assets/images/adminlte_logo.png"),
      projectName: "AdminLte",
      projectDesc: "Admin dashboards, role-based UI, enterprise feel",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://adminlte.io/"
        }
      ]
    },
    {
      image: require("./assets/images/vercel_devhire_logo.png"),
      projectName: "DevHire",
      projectDesc: "Connect tech talents with potential employers",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://dev-hire-vp.vercel.app/"
        }
      ]
    },
    {
      image: require("./assets/images/vercel_v_track_logo.png"),
      projectName: "V-Track",
      projectDesc: "Expense tracking",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://vtrack-expense.vercel.app/"
        }
      ]
    },
    {
      image: require("./assets/images/vercel_climate_logo.png"),
      projectName: "klimatee - weather",
      projectDesc: "Climate/Eco-related, product showcase",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://klimatee.vercel.app/"
        }
      ]
    },
    {
      image: require("./assets/images/vercel_bank_logo.png"),
      projectName: "HooBank",
      projectDesc: "Modern banking-style dashboard demo, prototype",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://bank-modern-app-r9rw.vercel.app/"
        }
      ]
    },
    {
      image: require("./assets/images/vercel_e_commerce_logo.png"),
      projectName: "E-commerce",
      projectDesc: "E-commerce store interface",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://vijay-ecommerce.vercel.app/"
        }
      ]
    },
    {
      image: require("./assets/images/tableau_logo.png"),
      projectName: "Tableau",
      projectDesc: "Powerful data visualization and analytics platform",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.tableau.com/"
        }
      ]
    },
    {
      image: require("./assets/images/habitica_logo_icon_170043.webp"),
      projectName: "Habtica",
      projectDesc: "Gamified productivity and habit-tracking platform",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://habitica.com/static/home"
        }
      ]
    },
    {
      image: require("./assets/images/cachet_logo.png"),
      projectName: "Cachet",
      projectDesc: "Open-source status page and incident management platform",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://cachethq.io/"
        }
      ]
    },
    {
      image: require("./assets/images/appsmith-dark.png"),
      projectName: "Appsmith",
      projectDesc: "Low-code platform for building business tools and dashboards",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.appsmith.com/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Certificates🏆"),

  achievementsCards: [
    {
      title: "Software Engineer",
      image: require("./assets/images/certificates_software_engineer.png"),
      footerLink: [
        {
          name: "View",
          url: "https://www.hackerrank.com/certificates/0c838da72779"
        }
      ]
    },
    {
      title: "Frontend Developer",
      image: require("./assets/images/certificates_frontend_react.png"),
      footerLink: [
        {
          name: "View",
          url: "https://www.hackerrank.com/certificates/9f74437d2bfb"
        }
      ]
    },
    {
      title: "Problem Solving",
      image: require("./assets/images/certificates_problem_solving.png"),
      footerLink: [
        {
          name: "View",
          url: "https://www.hackerrank.com/certificates/0ca86cef855b"
        }
      ]
    },
    {
      title: "Go",
      image: require("./assets/images/certificates_language_go.png"),
      footerLink: [
        {
          name: "View",
          url: "https://www.hackerrank.com/certificates/6c58048da395"
        }
      ]
    },
    {
      title: "JavaScript",
      image: require("./assets/images/certificates_language_javascript.png"),
      footerLink: [
        {
          name: "View",
          url: "https://www.hackerrank.com/certificates/b1539890278d"
        }
      ]
    },
    {
      title: "SQL",
      image: require("./assets/images/certificates_sql.png"),
      footerLink: [
        {
          name: "View",
          url: "https://www.hackerrank.com/certificates/b179376edf99"
        }
      ]
    },
  ],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+55 71 98399 5712",
  email_address: "marcusviniciusdossantosbr@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
